<template>
    <v-app class="us-v-app">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goBack">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;">注册企业</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <v-content>
            <v-container style="padding-top:3rem;">
              <div v-if="isSpecial" style="font-size: 1.5rem;text-align: center;color:#9e9e9e;">特殊用户</div>
                <!-- <div style="width:90%;margin:auto;text-align:center;margin-top:5rem;">
                    <div style="font-size:1.4rem;">输入企业的名字</div>
                    <div style="margin-top:1rem;">
                        <v-text-field v-model="form.ent_name"></v-text-field>
                    </div>
                    <div style="margin-top:1rem;">
                        <v-btn large color="success" style="width:80%;" :loading="submitLoading" :disabled="submitLoading" @click="submit">完成创建</v-btn>
                    </div>
                    <div style="margin-top:1rem;font-size:0.75rem;color:#9e9e9e;">最多只能注册一个</div>
                </div> -->
                <div style="width:90%;margin:auto;text-align:center;">
                  <v-row no-gutters style="position: relative;">
                    <div style="width: 80px;padding-top: 24px;margin-top: 4px;position: absolute;">
                      <span class="us-span">企业名称</span>
                    </div>
                    <div style="margin-left: 80px;width:100%;">
                      <v-text-field v-model="form.ent_name" placeholder="填写企业名称 (必填)" style="width:100%"></v-text-field>
                    </div>
                  </v-row>
                  <v-row no-gutters style="position: relative;">
                    <div style="width: 80px;padding-top: 24px;margin-top: 4px;position: absolute;">
                      <span class="us-span">统一社会 信用代码</span>
                    </div>
                    <div style="margin-left: 80px;width:100%;">
                      <!-- <v-text-field v-model="form.credit_code" placeholder="填写统一社会信用代码" style="width:100%"></v-text-field> -->
                      <v-textarea  v-model="form.credit_code" auto-grow rows="2" placeholder="填写统一社会信用代码 (必填)" style="width:100%"></v-textarea>
                    </div>
                  </v-row>
                  <v-row no-gutters style="position: relative;">
                    <div style="width: 80px;padding-top: 24px;margin-top: 4px;position: absolute;">
                      <span class="us-span">联系人</span>
                    </div>
                    <div style="margin-left: 80px;width:100%;">
                      <v-text-field v-model="form.ent_cont_name" placeholder="填写联系人 (必填)" style="width:100%"></v-text-field>
                    </div>
                  </v-row>
                  <v-row no-gutters style="position: relative;">
                    <div style="width: 80px;padding-top: 24px;margin-top: 4px;position: absolute;">
                      <span class="us-span">联系电话</span>
                    </div>
                    <div style="margin-left: 80px;width:100%;">
                      <v-text-field v-model="form.ent_cont_tel" placeholder="填写联系电话 (选填)" style="width:100%"></v-text-field>
                    </div>
                  </v-row>
                  <v-row no-gutters style="position: relative;">
                    <div style="width: 80px;padding-top: 24px;margin-top: 4px;position: absolute;">
                      <span class="us-span">联系邮箱</span>
                    </div>
                    <div style="margin-left: 80px;width:100%;">
                      <v-text-field v-model="form.ent_cont_email" placeholder="填写联系邮箱 (选填)" style="width:100%"></v-text-field>
                    </div>
                  </v-row>
                  <v-row no-gutters style="position: relative;">
                    <div style="width: 80px;padding-top: 24px;margin-top: 4px;position: absolute;">
                      <span class="us-span">企业地址</span>
                    </div>
                    <div style="margin-left: 80px;width:100%;">
                      <v-textarea  v-model="form.ent_site" auto-grow rows="1" placeholder="填写企业地址 (必填)" style="width:100%"></v-textarea>
                    </div>
                  </v-row>
                  <v-row no-gutters style="position: relative;">
                    <div style="width: 80px;padding-top: 24px;margin-top: 4px;position: absolute;">
                      <span class="us-span">备注</span>
                    </div>
                    <div style="margin-left: 80px;width:100%;">
                      <v-textarea  v-model="form.remark" auto-grow rows="1" placeholder="填写备注 (选填)" style="width:100%"></v-textarea>
                    </div>
                  </v-row>
                  <div style="margin-top:1rem;">
                      <v-btn large color="success" style="width:80%;" :loading="submitLoading" :disabled="submitLoading" @click="submit">注册企业</v-btn>
                  </div>
                  <div style="margin-top:1rem;font-size:0.75rem;color:#9e9e9e;">最多只能注册一个</div>
                </div>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {
      companyName: '',
      btnDisabled: true,
      submitLoading: false,
      isSpecial: false,
      form: {
        ent_name: '',
        credit_code: '',
        ent_cont_name: '',
        ent_cont_tel: '',
        ent_cont_email: '',
        ent_site: '',
        remark: ''
      }
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    var is_special = that.$route.query.is_special
    if (is_special === true || is_special === 'true') {
      that.isSpecial = true
    } else {
      that.isSpecial = false
    }
    // console.log(is_special, that.isSpecial)
  },
  created() {
  },
  methods: {
    goBack: function() {
      var that = this;
      that.$router.goBack()
    },
    changeName() {
      var that = this
      that.btnDisabled = that.companyName === ''
    },
    submit() {
      var that = this
      if (!that.form.ent_name) {
        that.$toast.warning('企业名称不能为空')
        return
      }

      if (!that.isSpecial) {
        if (!that.form.credit_code) {
          that.$toast.warning('统一社会信用代码不能为空')
          return
        }

        if (!that.form.ent_cont_name) {
          that.$toast.warning('联系人不能为空')
          return
        }

        // if (!that.form.ent_cont_tel) {
        //   that.$toast.warning('联系电话不能为空')
        //   return
        // }

        // if (!that.form.ent_cont_email) {
        //   that.$toast.warning('联系邮箱不能为空')
        //   return
        // }

        if (!that.form.ent_cont_tel && !that.form.ent_cont_email) {
          that.$toast.warning('联系电话、联系邮箱至少填写一个')
          return
        }

        if (!that.form.ent_site) {
          that.$toast.warning('企业地址不能为空')
          return
        }
      }

      var ent = {
        ent_name: that.form.ent_name,
        credit_code: that.form.credit_code,
        ent_cont_name: that.form.ent_cont_name,
        ent_cont_tel: that.form.ent_cont_tel,
        ent_cont_email: that.form.ent_cont_email,
        ent_site: that.form.ent_site,
        remark: that.form.remark
      }
      that.submitLoading = true
      that.$api.bz.createEnterPrise({ str_enterprise: JSON.stringify(ent) }).then(res => {
        that.submitLoading = false
        console.log('生成企业邀请码', res)
        if (!res.success) {
          that.$toast.error(res.error_msg ? res.error_msg : '注册失败')
          // that.$router.goActionResPage({ tag: 0, text: '创建失败', auto_ret: 'b' });
          return
        }
        that.$router.goActionResPage({ tag: 1, text: '注册成功', auto_ret: 'y', dest: -2, refresh: true });
      }).catch(e => {
        that.submitLoading = false
        console.log('请求错误', e)
        that.$toast.error('注册失败')
        // 类似try{}catch(e){} 你可以理解为省略了try()
      })
    }
  }
}
</script>

<style scoped>
</style>
